import dispatcher from "../dispatcher"
import { IDate } from "../models"

export function handleChangeReferenceDate(referenceDate: IDate) {
    setTimeout(() =>
        dispatcher.dispatch({
            type: "RECEIVE_TIMECARD_REFERENCE_DATE",
            data: referenceDate
        })
        , 0)
}